import timeout from "../../../utils/timeout";

const handleSimpleFormSrollToError = async (key: string) => {
  await timeout(400);
  const scrollTo = document.getElementById("s-form-" + key);
  if (scrollTo) {
    scrollTo.scrollIntoView({
      behavior: "smooth",
      block: "center",
      inline: "center",
    });
  }
  await timeout(200);
  return;
};

export default handleSimpleFormSrollToError;
